import { InjectionKey } from "vue";
import BasePricePlanDTO = Modules.BasePrice.Data.BasePricePlanDTO;
import BasePricePlanMinimalDTO = Modules.BasePrice.Data.BasePricePlanMinimalDTO;

/** The part of an editor store the versions drawer reads and drives. */
export interface VersionsDrawerStore {
	plan: BasePricePlanDTO | null;
	versions: BasePricePlanMinimalDTO[];
	loadingVersions: boolean;
	hasUnsavedChanges: boolean;
	loadVersions: () => unknown;
	loadPlan: (uuid: string) => Promise<unknown>;
	markUnsaved: () => void;
	loadResolvedPlan: (uuid: string) => unknown;
}

/**
 * What an editor hands PlanVersionsDrawer so one drawer serves both pricing
 * models. Nothing provided means the netto editor, which is what the drawer
 * was built for.
 */
export type VersionsDrawerSource = {
	store: VersionsDrawerStore;
	/** Where a version of this chain is edited. */
	editPath: (uuid: string) => string;
	/** Whether a version has a target and books worth showing — not for bruto. */
	showBudget: boolean;
};

export const versionsDrawerSourceKey: InjectionKey<VersionsDrawerSource> =
	Symbol("base-price-versions-drawer");
